<template>
  <div class="rootdiv">
    <Cell class="cell" title="帐号">
      <span>{{ user.account }}</span>
    </Cell>
    <Cell class="cell" title="头像" is-link v-on:click.native="openPicture">
      <avatar username="Birth Circle" style="margin-top: 0.5rem;margin-bottom: 0.5rem" v-if="selectedAvatar === null"
              v-bind:src="user.avatarUrl"
              :size="50">
      </avatar>
      <avatar username="Birth Circle" style="margin-top: 0.5rem;margin-bottom: 0.5rem" v-if="selectedAvatar !== null"
              v-bind:src="selectedAvatar"
              :size="50">
      </avatar>
    </Cell>
    <Cell class="cell" title="昵称" v-on:click.native="openName" is-link>
      <span>{{ user.userName }}</span>
    </Cell>
    <Cell class="cell" title="性别" v-on:click.native="SexPickerControl(false)" is-link>
      <span>{{ user.sex }}</span>
    </Cell>
    <Cell class="cell" title="出生日期" v-on:click.native="openDatePicker" is-link>
      <span>{{ user.date }}</span>
    </Cell>
    <div style="float: left;padding-left: 0.5rem;margin-top: 0.5rem;margin-bottom: 0.5rem;width: 100%">
      <div style="float:left;margin-top: 0.5rem">
        <span>日期类型</span>
      </div>
      <div style="float:right;margin-right: 1.5rem">
        <mt-switch v-model="tempDateType"></mt-switch>
      </div>
      <div style="float:right;margin-top: 0.4rem;margin-right: 0.5rem">
        <span v-if="tempDateType">公历</span>
        <span v-else>农历</span>
      </div>
    </div>
    <Cell class="cell" style="clear: both;" title="出生时间" v-on:click.native="openTimePicker" is-link>
      <span>{{ user.time }}</span>
    </Cell>
    <Field label="个性签名" type="textarea" style="text-align: left;vertical-align: center" rows="4"
           v-model="user.remarks"></Field>
    <Button size="large" class="addbutton" @click="SaveChange">保 存</Button>
    <DatetimePicker
        ref="date_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDate" @confirm="DateConfirm">
    </DatetimePicker>
    <DatetimePicker
        ref="time_picker"
        type="time"
        hour-format="{value} 时"
        minute-format="{value} 分"
        v-model="tempTime" @confirm="TimeConfirm">
    </DatetimePicker>
    <Popup class="sexpopup"
           v-model="popupVisible"
           position="bottom">
      <div class="buttondiv">
        <div class="buttondiv1"><span @click="SexPickerControl(false)">取消</span></div>
        <div class="buttondiv2"><span @click="SexPickerControl(true)">确定</span></div>
      </div>
      <div class="line"></div>
      <div class="pickerdiv">
        <Picker :slots="slots" @change="onValuesChange"></Picker>
      </div>
    </Popup>
    <input style="float: left;  display: none;" type="file" id='uploadFile' accept="image/*"
           v-on:change="readLocalFile()">
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import {Cell, DatetimePicker, Picker, Popup, Button, Field, Indicator} from 'mint-ui';
import Mine from './Mine';

export default {
  name: "MyInfo",
  components: {
    Avatar,
    Cell,
    DatetimePicker,
    Picker,
    Popup,
    Button,
    Field
  },
  data() {
    return {
      selectedAvatar: null,
      user: Mine.data().user,
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      slots: [
        {
          flex: 1,
          values: ['保密', '男', '女'],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      popupVisible: false,
      startDate: new Date("1901-01-01"),
      endDate: new Date(),
      tempDate: new Date("1990-01-01"),
      tempTime: '00:00',
      tempSex: null,
      tempDateType: false,
      SaveUrl: '/api/user/updateUserInfo',
      UploadAvatarUrl: '/api/user/uploadAvatarUrl',
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"))
    if (this.user.avatarUrl === null) {
      const data = require('/public/config/data.json')
      this.user.avatarUrl = data['defaultAvatarUrl']
    }
    if (this.user.dateType != null) {
      this.tempDateType = this.user.dateType === '公历'
    }
    if (this.$route.params.avatar !== undefined) {
      this.selectedAvatar = this.$route.params.avatar//获取裁剪后的头像
    }
  },
  methods: {
    openPicture() {
      document.getElementById("uploadFile").click();
    },
    //点击选中图片
    readLocalFile: function () {
      const localFile = document.getElementById("uploadFile").files[0];
      const reader = new FileReader();
      const current = this;
      reader.onload = function (event) {
        current.selectedAvatar = event.target.result;//获取图片base64代码
        current.$router.push({name: 'm_avatar_editor', params: {avatar: current.selectedAvatar}});
      }
      reader.readAsDataURL(localFile, "UTF-8");
    },
    UpdateMySelfInfo(updateMyself) {
      let that = this
      that.user.dateType = that.tempDateType ? '公历' : '农历'
      that.$ajax({
        method: 'get',
        url: that.SaveUrl,
        params: {yhnm: that.yhnm, user: that.user, updateMyself: updateMyself},
        headers: {token: that.token}
      }).then((response) => {
            let result = response.data['result']
            if (!result) {
              that.$router.replace({name: 'm_mine', params: {refresh: 'true'}})
            } else {
              //上传头像
              if (that.selectedAvatar != null && that.selectedAvatar !== '') {
                Indicator.open({
                  text: '头像上传中...',
                  spinnerType: 'fading-circle'
                });
                that.$ajax({
                  method: 'POST',
                  url: that.UploadAvatarUrl,
                  data: {yhnm: that.yhnm, avatar: that.selectedAvatar},
                  headers: {token: that.token}
                }).then((response) => {
                  Indicator.close();
                  let result = response.data['result']
                  if (!result) {
                    that.$toast({
                      message: "头像更新失败！" + response.data['message'],
                      position: 'middle',
                    });
                  } else {
                    localStorage.setItem("localAvatar", that.selectedAvatar)
                  }
                  that.$router.replace({name: 'm_mine', params: {refresh: 'true'}})
                }).catch(response => {
                  that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商2" + response, '服务器异常')
                })
              } else
                that.$router.replace({name: 'm_mine', params: {refresh: 'true'}})
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async SaveChange() {
      let that = this
      if (that.user.time != null && that.user.date == null) {
        that.$toast({
          message: "请选择出生日期",
          position: 'middle',
        });
        return
      }
      that.$messagebox({
        title: '提示',
        message: '是否添加或更新主页中自己的生日信息?',
        confirmButtonText: '是',
        cancelButtonText: '否',
        showCancelButton: true
      }).then(res => {
        if (res === 'confirm') {
          that.UpdateMySelfInfo(true)
        } else {
          that.UpdateMySelfInfo(false)
        }
      })
    },
    openDatePicker() {
      if (this.user.date != null)
        this.tempDate = this.user.date
      this.$refs.date_picker.open();
    },
    openTimePicker() {
      if (this.user.time != null)
        this.tempTime = this.user.time
      this.$refs.time_picker.open();
    },
    DateConfirm() {
      this.user.date = this.formatDate(this.tempDate)
    },
    openName() {
      let message = this.$messagebox
      let rvalue = this.user.userName
      message.prompt(' ', '请输入昵称', {inputValue: rvalue}).then(({value, action}) => {
        if (action === 'confirm') {
          this.user.userName = value
        }
      })
    },
    openRemarks() {
      let message = this.$messagebox
      let rvalue = this.user.remarks
      message.prompt(' ', '请输入备注', {inputValue: rvalue}).then(({value, action}) => {
        if (action === 'confirm') {
          this.user.remarks = value
        }
      })
    },
    TimeConfirm() {
      this.user.time = this.tempTime
    },
    SexPickerControl(val) {
      if (val) {
        this.user.sex = this.tempSex
      }
      this.popupVisible = !this.popupVisible
    },
    onValuesChange(picker, values) {
      this.tempSex = values[0]
    },
    //更改时间格式
    formatTen(num) {
      return num > 9 ? (num + "") : ("0" + num);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
  }
}
</script>

<style lang="less" scoped>
.rootdiv {
  margin-top: -0.5rem;
}

.cell {
  text-align: left;
}

.sexpopup {
  width: 100%;
  padding-top: 1rem;

  span {
    color: #2986de;
    font-size: 1rem;
  }
}

.buttondiv1 {
  width: 50%;
  float: left;
}

.buttondiv2 {
  width: 50%;
  float: left;
}

.pickerdiv {
  clear: both;
}

.line {
  width: 100%;
  border-top: solid gray 0.5px;
  margin-top: 1.8rem;
}

.addbutton {
  background: lightseagreen;
  margin-top: 5rem;
}
</style>
